import React from 'react';
import '../App.css';
import Header from '../components/Header';
import Menu from '../components/Menu';
import Footer from '../components/Footer';
import AOS from "aos";
import "aos/dist/aos.css";
import WelcomeSmall from '../components/WelcomeSmall';
import TextBlog from '../components/TextBlog';

function blog() {
  
    AOS.init();
  

  return (
    <div className="App">
      <Header />
      <Menu />
      <WelcomeSmall />
      <TextBlog />
      <Footer/>
    </div>
  );
}

export default blog;
